import React from 'react';
import { Typography, CardMedia } from '@material-ui/core';
import QRCode from 'qrcode.react'
import ES from 'components/ExplainString';
import explains from 'data/explains'


const data = (
<Typography component="div">
  <h1>Portfolio</h1>

  <h2>Background</h2>
  The plan for creating this Portfolio page has been long, but pushed back due to I find more interesting and worthwhile project to do. The final kick comes when my University asked me to create one for some delicious marks.🤤 <br/><br/>

  If I decide to do something, I need to make sure it's prefect and worthwhile, that's why I decided to create this page from starch.
  I was able to learn and pick up best practices for <ES {...explains['React']}>React</ES>, <ES {...explains['MUI']}>Material-Ui</ES> and <ES {...explains['ExpressJs']}>Express</ES> while I making this page.


  <h2>Reactive Page</h2>
  I found two significant advantages of using react. From programming and management point of view, organizing code into components allows more code reusable and more maintainable code. I feel delighted when coming across <ES {...explains['ReactHook']}>React Hook</ES>, as it brings <ES {...explains['FP']}>Functional Programing</ES> to frontend making code less prone to mistake. <br/><br/>

  The second advantage is for the viewer, it makes this page adaptable to different screen sizes, and each component remembers its state. The best way to explore this is to change the window size of your browser, or scan the QR code below to explore on your phone. <br/>

  <QRCode value={window.location.href}/>



  <h2>Leverage Cloud Service</h2>
  Due to the rise of the cloud service and infrastructure, the cost of hosting personal service is negligible. By leveraging these cloud infrastructure, it's easy for individuals and small business to provide service with high availability without having a dedicated server room with fan running 24/7.  <br/><br/>

  I used Github to backup my code and Github Page to host static website (i.e. the page you are reading) with <ES {...explains['GithubAva']}>99.9% availability</ES>. To allow dynamic content and understand if anyone is visiting my website, I use Google Cloud Function, Google Cloud Firestore and Google analytics. (I could pick AWS Lambda as well, but I find <ES {...explains['GcloudCli']}>Google's example easier to follow and setup</ES>)


  <h2>Security and Privacy</h2>
  Although I would like to open source my portfolio to demonstrate my coding and project management skills, just like a business, there are some codes that I could like to keep private for security and privacy reasons. To address this conflict of interest, I decided to make the frontend completely open since it is viewable from browser anyone, so close source would not prevent malicious attack on possible vulnerability. <br/><br/>

  But for more sensitive backend which may contains valuable data that an attacker would like to steal. The code is written with care and kept close source to prevent the white box attack. Also, frontend code only handles input validation and kept business logic minimal, the backend revalidates and sanitizes the input to prevent injection attack.


  <h2>Project Management</h2>
  To organize this complex project, I used git submodules, branches and various management tools provided by Github. For more insight please follow the Github link below.

</Typography>
)
export default data